<template>
	<div class="iframe-field">
		<iframe @load="iframeLoaded" :ref="fieldRef" :src="url" height="600" width="100%" title="Open url"></iframe>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import WidgetFieldMixin from './WidgetFieldMixin';
import WidgetFormService from '../../WidgetForm/WidgetFormService';

const LOADED_THRESHOLD = 2;

export default {
	name: 'IframeField',
	mixins: [WidgetFieldMixin],
	props: {
		previousSteps: { type: Object },
		replaceInsertDataStringDict: { type: Object },
		configurationsMappingBlocksUUIDs: { type: Array },
	},
	computed: {
		...mapGetters('selectedNode', ['flatPreviousSteps']),
		currentPreviousSteps() {
			return this.previousSteps || this.flatPreviousSteps;
		},
		url() {
			try {
				let currentBaseUrl = this.field.metadata.options.previous_steps.url.value;
				if (this.currentPreviousSteps) {
					currentBaseUrl = WidgetFormService.processPreviousSteps(
						this.field.metadata.options.previous_steps.url.value,
						this.currentPreviousSteps,
						this.replaceInsertDataStringDict,
						this.configurationsMappingBlocksUUIDs
					);
				}
				const url = new URL(currentBaseUrl);
				if (this.queryStrings) {
					this.queryStrings.forEach((param) => {
						url.searchParams.set(param.text, param.value);
					});
				}
				return url.href;
			} catch {
				return '';
			}
		},
		queryStrings() {
			const queryStrings = [];
			if (this.field.metadata.options.previous_steps.query_params) {
				if (!this.currentPreviousSteps) {
					return this.field.metadata.options.previous_steps.query_params;
				}

				this.field.metadata.options.previous_steps.query_params.forEach((param) => {
					if (param.value) {
						const copiedParam = cloneDeep(param);
						copiedParam.value = WidgetFormService.processPreviousSteps(
							param.value,
							this.currentPreviousSteps,
							this.replaceInsertDataStringDict,
							this.configurationsMappingBlocksUUIDs
						);
						queryStrings.push(copiedParam);
					}
				});
			}
			return queryStrings;
		},
	},
	methods: {
		iframeLoaded() {
			this.iframeLoadedCount = this.iframeLoadedCount + 1;
			if (this.iframeLoadedCount >= LOADED_THRESHOLD) {
				this.$emit('field-event', {
					action: 'iframeRedirected',
				});
			}
		},
	},
	data() {
		return {
			iframeLoadedCount: 0,
		};
	},
};
</script>
<style scoped lang="scss">
.iframe-field {
	margin-left: -8px;
}
</style>
